(function () {
  'use strict';

  angular
      .module('tf.retailer.Util')
      .filter('titleCase', titleCase);

  // @ngInject
  function titleCase() {
    return function(input) {
      input = input || '';
      return input.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    };
  }

})();